import type { Page } from '../../../types';
import { cn } from '@/lib/utils';
import {
    LAYOUT_NAV_SECTION_LABEL_CLASS,
    cnLayoutNavIcon,
    cnLayoutNavRow,
} from '../layoutNavTokens';
import { getSlugFromPage } from '../../../utils/routeUtils';
import { NAV_GROUPS } from './config';
import { handleSidebarNavClick } from './navHandlers';

interface SidebarNavigationProps {
    isOpen: boolean;
    currentPage: Page;
    setCurrentPage: (page: Page) => void;
}

export function SidebarNavigation({ isOpen, currentPage, setCurrentPage }: SidebarNavigationProps) {
    return (
        <nav
            aria-label="Navegação principal"
            className={cn(
                'hidden min-h-0 min-w-0 flex-col items-start md:flex',
                'flex-1 overflow-y-auto overflow-x-hidden',
                isOpen ? 'space-y-6 px-4' : 'space-y-2 px-2'
            )}
        >
            {NAV_GROUPS.map((group, groupIdx) => (
                <div key={groupIdx} className={cn('flex w-full flex-col', isOpen ? 'gap-1' : '')}>
                    {isOpen && (
                        <h4 className={cn(LAYOUT_NAV_SECTION_LABEL_CLASS, 'mb-2 px-2')}>{group.title}</h4>
                    )}
                    {group.items.map((item) => {
                        const Icon = item.icon;
                        const isActive = currentPage === item.id;
                        return (
                            <a
                                key={item.id}
                                href={`/${getSlugFromPage(item.id as Page)}`}
                                onClick={(e) => handleSidebarNavClick(e, setCurrentPage, item.id as Page)}
                                title={!isOpen ? item.label : undefined}
                                aria-current={isActive ? 'page' : undefined}
                                className={cn(
                                    'group relative flex items-center rounded-lg p-2 transition-all duration-200 md:p-2.5',
                                    isOpen ? 'w-full justify-start gap-4' : 'justify-center',
                                    cnLayoutNavRow(isActive)
                                )}
                            >
                                <Icon className={cn('h-5 w-5', cnLayoutNavIcon(isActive))} aria-hidden />
                                {isOpen && <span className="whitespace-nowrap text-sm font-medium">{item.label}</span>}
                                {!isOpen && (
                                    <span className="pointer-events-none absolute left-14 z-50 hidden rounded border border-border bg-surface px-2 py-1 text-xs text-default opacity-0 shadow-md transition-opacity group-hover:opacity-100 md:block whitespace-nowrap">
                                        {item.label}
                                    </span>
                                )}
                            </a>
                        );
                    })}
                </div>
            ))}
        </nav>
    );
}
